import React from 'react';
import { Path, Svg } from 'react-native-svg';

export interface DoubleArrowDownIconProps {
    size?: number;
    color?: string;
}

export function DoubleArrowDownIcon({ size = 24, color = '#000000' }: DoubleArrowDownIconProps) {
    return (
        <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            {/* Top chevron */}
            <Path
                d="M6 6L12 12L18 6"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Bottom chevron */}
            <Path
                d="M6 12L12 18L18 12"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
    );
}

